// Vendor imports
const { connect } = require('react-redux')
const { createSelector } = require('reselect')
// Client V2 common imports
const socialProviders = require('client-v2/common/containers/auth-modal/providers')
// Entry imports
const authActions = require('./actions')
const AuthSection = require('./component-dumb')

function mapStateToProps(state) {
  return {
    downloadHref: downloadHrefSelector(state),
    mobilePlatform: mobilePlatformSelector(state),
    socialProviders
  }
}

const mapDispatchToProps = {
  onAppDownload: authActions.trackAppDownload,
  onSocialProviderAuth: authActions.socialAuth
}

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  AuthSection
)

const mobilePlatformSelector = createSelector(
  state => state.env.browser,
  browser => {
    if (browser.has('android')) {
      return 'android'
    }
    if (browser.has('ios')) {
      return 'ios'
    }
  }
)

const downloadHrefSelector = createSelector(
  [
    state => state.env.deeplinkUrls,
    mobilePlatformSelector
  ],
  (deeplinkUrls, mobilePlatform) => {
    if (mobilePlatform) {
      return deeplinkUrls.get(mobilePlatform)
    }
  }
)
